import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const montessoriHoikuenDemerit: BlogMetaData = {
  title: 'モンテッソーリ保育園のデメリットは？集団行動・放任の不安と園の選び方',
  description:
    'モンテッソーリ保育園のデメリットや「集団行動が苦手にならない？」「放任では？」という不安を、懸念・問題になり得る条件・園選びで確認することの順に整理。モンテ歴20年以上の園長が、見学で見る観察ポイントを解説します。',
  thumbnailUrl: '/img/blog-montessori-hoikuen-demerit.webp',
  filePath: buildBlogFilePath('montessori-hoikuen-demerit'),
  category: BLOG_CATEGORY.NURSERY,
};
